import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { AuthService } from 'src/app/services/auth.service';
import { SmoochService } from 'src/app/services/smooch.service';
import { map } from 'rxjs/operators';
import { Region } from '../../models/region';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {

  region: Region;
  smoochAppId: string;
  facebookAppId: string;
  twitterEnv: string;

  constructor(private authService: AuthService, private smoochService: SmoochService) {
  }
  
  ngOnInit(): void {

    let savedCredential = sessionStorage.getItem('credential');

    if (savedCredential) {
      const credential = JSON.parse(savedCredential);
      this.region = credential.region;
      this.smoochAppId = credential.appId;
      this.loadApps(credential.region.id);
    }

    
  }

  logout() {
    this.authService.logout();
  }

  loadApps(regionId) {
    this.smoochService.getApp()
      .then(data => {
        if (data) {
          this.facebookAppId = data.find(f => f.regionId === regionId && f.type === 'facebook').id;
          this.twitterEnv = data.find(f => f.regionId === regionId && f.type === 'twitter').id;
        }
      })
      .catch(error => {
        if (error.error) {
          console.log("Error on loadApps: " + error.error.ExceptionMessage);
        }
        console.log("Error Message on loadApps: " + error.message);
      });
  }
}
